import {
    CONSTRAINT_CELL_BACKGROUNDS,
    StyledRecommendationCell,
} from '@/components/decisionSupport/tables/RecommendationsTable.styled';
import CheckIcon from '@mui/icons-material/CheckRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { FC } from 'react';

type ConstraintCellProps = {
    isSatisfied: boolean;
};

export const ConstraintCell: FC<ConstraintCellProps> = ({ isSatisfied }) => (
    <StyledRecommendationCell
        backgroundColor={
            isSatisfied
                ? CONSTRAINT_CELL_BACKGROUNDS.satisfied
                : CONSTRAINT_CELL_BACKGROUNDS.unsatisfied
        }
    >
        {isSatisfied ? <CheckIcon fontSize='small' /> : <CloseIcon fontSize='small' />}
    </StyledRecommendationCell>
);
